import Money from 'common/components/layout/Money';

const SalePrice = (props) => {
  const { product, settings } = props;
  if (!product.variants) {
    return null;
  }
  const multiplier = product.type === 'Wine' ? 12 : 1;
  const variant = product.variants[0];
  const price = variant.comparePrice || variant.price;
  if (!variant) {
    return null;
  }
  if (!variant.addToCartPrice) {
    return null;
  }
  if (variant.addToCartPrice >= price) {
    return null;
  }
  // TODO change class name to be sale-price, make it bold, and font size needs to be at least the font size of retail price - c7-product__variant-sale-price
  return (
    <div className="c7-product__variant__price__sale">
      {variant.actionMessage}{' '}
      <Money number={variant.addToCartPrice * multiplier} settings={settings} />
      {product.type === 'Wine' && <>/case</>}
      {product.type !== 'Wine' && <>/unit</>}
    </div>
  );
};

export default SalePrice;
